import { render, staticRenderFns } from "./ManagersNew.vue?vue&type=template&id=71a445b0&scoped=true"
import script from "./ManagersNew.vue?vue&type=script&lang=ts"
export * from "./ManagersNew.vue?vue&type=script&lang=ts"
import style0 from "./ManagersNew.vue?vue&type=style&index=0&id=71a445b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a445b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a445b0')) {
      api.createRecord('71a445b0', component.options)
    } else {
      api.reload('71a445b0', component.options)
    }
    module.hot.accept("./ManagersNew.vue?vue&type=template&id=71a445b0&scoped=true", function () {
      api.rerender('71a445b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/contractorDetails/ManagersNew.vue"
export default component.exports